import { FeedbackSubjectDetail } from '@shared/model/feedback-subject';

export const normalizeInitialValues = (values?: FeedbackSubjectDetail) => {
    if (!values) {
        return {
            active: 'true',
            sort: 100,
            users: [],
        };
    }

    return {
        ...values,
        active: String(values.active),
    };
};
